module.exports = __webpack_public_path__ + "img/container.157ca963.png";